import React, { useState, useEffect } from "react"
import DatePicker from "react-multi-date-picker"

export default function Calendar(props) {
  const today = new Date()
  const [values, setValues] = useState(props.startDate ? new Date(props.startDate) : today)

  useEffect(() => {
    props.changeStartDate(values);
  }, [values]);

  return (
    <DatePicker 
      value={values} 
      onlyMonthPicker={props.isOnlyMonthPicker ? true: false}
      minDate={new Date()}
      onChange={setValues}
      fixMainPosition={true}
      calendarPosition={props.bottomLeftPosition ? 'bottom-left' : 'top-left'}
      format={ props.formDataPicker ? props.formDataPicker :  'MM/DD/YYYY' }
    />
  )
}


// WEBPACK FOOTER //
// ./src/components/assignments/StartCalendar.js